import { request } from '../request'
// 2022新版样本接口

// 获取样本列表数据
export function getSamplePageList(data, params) {
  return request({
    url: '/wjsample/wjsample/page',
    method: 'POST',
    params,
    data
  })
}

export function getSampleGroup(data, args) {
  const params = {
    descs: 'create_time',
    current: 1,
    size: 9999
  }
  Object.assign(params, args)
  return request({
    url: 'wjsample/wjsamplegroup/page',
    method: 'POST',
    data: data || {},
    params
  }).then(res => {
    const groups = res?.data?.data?.records || []
    return groups.map(item => {
      return {
        id: item.id,
        groupName: item.groupName
      }
    })
  })
}

export function saveSmsSamples(data) {
  return request({
    url: '/wjsample/wjsample/saveSampleIdsForSms',
    method: 'POST',
    data
  })
}

export function removeSmsSamples(data) {
  return request({
    url: '/wjsample/wjsample/removeSampleForSms',
    method: 'POST',
    data
  })
}

export function getSmsSamples(params) {
  return request({
    url: '/wjsample/wjsample/getSampleForSms',
    method: 'GET',
    params
  })
}

//样本属性表新增或修改
export function setSampleAttribute(data) {
  return request({
    url: '/wjsample/wjSampleAttribute/set',
    method: 'POST',
    data
  })
}

//获取租户全部属性
export function getAllAttribute(params) {
  return request({
    url: '/wjsample/wjSampleAttribute/getAllAttribute',
    method: 'GET',
    params
  })
}

//属性顺序移动
export function moveSampleAttribute(params, data) {
  return request({
    url: '/wjsample/wjSampleAttribute/move',
    method: 'POST',
    data,
    params
  })
}

//样本属性表删除
export function delSampleAttribute(params) {
  return request({
    url: '/wjsample/wjSampleAttribute/del',
    method: 'POST',
    params
  })
}

//样本属性表保存修改
export function saveChangeSampleAttribute(data) {
  return request({
    url: '/wjsample/wjSampleAttribute/saveChange',
    method: 'GET',
    data
  })
}

// 获取短信审核状态
export function getQuerySmsAuditH(params) {
  return request({
    url: '/wenjuan/sensitive/querySmsAudit',
    method: 'GET',
    params
  })
}
// 审核成功后调用此接口 可重新再次群发
export function updateSmsAuditH(params) {
  return request({
    url: '/wenjuan/sensitive/updateSmsAudit',
    method: 'GET',
    params
  })
}

// 退款
export function refundSmsH(params) {
  return request({
    url: '/answer/sms/refundSms',
    method: 'GET',
    params
  })
}
